import PreLoader from "components/PreLoader/PreLoader";
import { Content } from "containers/RightPanel/RightPanel.styles";
import styled from "styled-components";
import { HeaderTitle } from "styles/outgoingStyles";

export const Spinner = styled(PreLoader)`
  position: absolute;
`;

export const Parcel = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.whiteSmoke};
  padding: 18px 0 10px;

  &:first-child {
    padding: 0;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ParcelTitle = styled(HeaderTitle)`
  justify-content: space-between;

  span {
    color: ${(props) => props.theme.black};
    font-weight: 700;
    margin-left: 4px;
  }
`;

export const ParcelText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 12px 0;
  padding-left: 5px;
`;

export const ParcelService = styled.span`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const ParcelAmount = styled.span`
  flex-shrink: 0;
  color: ${({ theme }) => theme.black};
  font-weight: 700;
`;

export const ParcelBreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 8px 0 10px;
  padding-left: 46px;
  color: ${({ theme }) => theme.textSubtle};
  font-size: 16px;
`;

export const ScrollableContent = styled(Content)`
  & > div:first-child {
    display: flex;
    flex-direction: column;
  }
`;

export const PaymentSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const PaymentSummary = styled.div`
  border-top: 1px solid ${({ theme }) => theme.whiteSmoke};
  border-bottom: 1px solid ${({ theme }) => theme.whiteSmoke};
  margin-top: 18px;
  padding: 14px 0;
`;

export const PaymentSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin: 8px 0;
  color: ${({ theme }) => theme.black};
  font-size: 16px;
`;

export const PaymentSummaryTotalRow = styled(PaymentSummaryRow)`
  margin-top: 14px;
  font-size: 18px;
  font-weight: 700;
`;

export const PaymentSummaryAmount = styled.span`
  flex-shrink: 0;
  font-weight: 700;
`;
